import { Component, OnInit, Output, Input, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-confirm-window',
    templateUrl: './confirm-window.component.html',
    styleUrls: ['./confirm-window.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConfirmWindowComponent implements OnInit {

	@Input() title: string;
	@Input() subtitle: string;
	@Input() type: string = 'confirmation';
	@Input() cancelText: string = 'Cancel';
	@Input() confirmText: string = 'Confirm';
	@Input() hideCancel: boolean = false;

	@Output() closeView = new EventEmitter<any>();
	@Output() confirm = new EventEmitter<any>();
	@Output() cancelModal = new EventEmitter<string>();

	onConfirm() {
		this.confirm.emit();
	}

	close() {
		this.closeView.emit()
	}

	cancel(){
		this.cancelModal.emit();
	}

	constructor() { }

	ngOnInit() {
	}


}
